export enum Platform {
  JuvoPos = "JuvoPos",
  JuvoKiosk = "JuvoKiosk",
  JuvoOlo = "JuvOnline",
}

export enum PlatformAbreviature {
  POS = "POS",
  OLO = "OLO",
  KIOSK = "KIOSK",
}